import styled from 'styled-components';

export const RowAColA = styled.div`
  grid-area: rowAColA;
`;

export const RowAColB = styled.div`
  grid-area: rowAColB;
`;

export const RowBColA = styled.div`
  grid-area: rowBColA;
`;

export const RowBColB = styled.div`
  grid-area: rowBColB;
`;

export const RowBColC = styled.div`
  grid-area: rowBColC;
`;

export const RowBColD = styled.div`
  grid-area: rowBColD;
`;

export const Template = styled.div`
  display: grid;
  grid-template-columns: 0.25fr 0.25fr 0.25fr 0.25fr;
  grid-template-rows: 200px 200px;
  grid-gap: 30px;
  grid-template-areas:
    'rowAColA rowAColA rowAColB rowAColB'
    'rowBColA rowBColB rowBColC rowBColD';
`;
